import {
	TENTATIVE_EXPENSE_NAME,
	TENTATIVE_EXPENSE_TYPE,
} from "web_myplann/Finances/constants";
import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";

export const createTentativeExpense = (
	id: number | null,
	monthlyPayment: number,
): FinanceState["expenses"][number] => ({
	id,
	type: TENTATIVE_EXPENSE_TYPE,
	name: TENTATIVE_EXPENSE_NAME,
	monthlyPayment,
	sustainableAmount: 0,
});
